<a type="button" class="btn btn-default" (click)="onScanRandomRfidCardIdClick()">{{ 'Scan Random Rfid Card' | translate }}</a>
<input list="rfidCardCodes" name="rfidCardCode" [(ngModel)]="rfidCardCode">
<datalist id="rfidCardCodes">
  <option *ngFor="let rfidCardCodeItem of rfidCardCodes" value="{{ rfidCardCodeItem }}">
</datalist>
<a type="button" class="btn btn-default" (click)="onScanRfidCardClick()">{{ 'Scan Rfid Card' | translate }}</a>
<a type="button" class="btn btn-default" (click)="onInvalidRfidClick()">{{'Invalid RFID'| translate }}</a>
